<app-compliance-nav [activeMenuItem]="'pep'"></app-compliance-nav>


<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px">

        <mat-button-toggle-group>
          <mat-button-toggle #allButton class="mat-b-toggle-thin" (click)="filterStatus(0)" value="0">
            <label class="label-for-mat-toggle-button">All</label></mat-button-toggle>
          <mat-button-toggle #pendingButton checked class="mat-b-toggle-thin" (click)="filterStatus(1)"><label
            class="label-for-mat-toggle-button">Possible Matches</label></mat-button-toggle>
          <mat-button-toggle class="mat-b-toggle-thin" (click)="filterStatus(2)"><label
            class="label-for-mat-toggle-button">Done</label></mat-button-toggle>


        </mat-button-toggle-group>


      </div>
    </div>
    <!--
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search" [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
    -->
  </div>
  <div *ngIf="dataSource && dataSource.isLoading" style="margin-top: 10px;">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <ng-container *ngFor="let row of dataSource.data">
    <mat-card class="content-card" style="margin-top: 15px;">
      <mat-card-header>
        <mat-card-title>
          <h5 *ngIf="row.customerId">
            {{row.customer.firstName}} {{row.customer.lastName}}, {{row.customer.address}}, {{row.customer.zipCode}} {{row.customer.city}}
          </h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="list-item" fxLayout="row">
          <label fxFlex="15" class="secondary">Ident</label>
          <label fxFlex="65" >{{ row.identifiedOn | date: "dd.MM.yyyy" }}, {{ getIdentStatusString(row) }}</label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="15" class="secondary">Document</label>
          <label fxFlex="65" >{{ row.bioDataFirstName }} {{ row.bioDataLastName }}, {{ row.bioDataDob  | date: "dd.MM.yyyy"}}</label>
        </div>



        <div class="list-item" fxLayout="row" *ngIf="row.veriffPepDetails != null && row.veriffPepDetails.length > 0">
          <label fxFlex="80" >

            <div style="margin-bottom: 5px;" *ngIf="row.veriffPepDetails != null && row.veriffPepDetails.length > 0">
              <mat-expansion-panel #panel style="box-shadow: none !important; border: 1px dotted gray;">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="panel.expanded">Hide PEP details</div>
                    <div *ngIf="!panel.expanded">
                      <b>{{ getVeriffHitTypesStringCombined(row.veriffPepDetails) }}</b>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description>

                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div *ngFor="let item of row.veriffPepDetails" style="">
                  <div *ngFor="let item of item.hits" style="">
                    <div><b>{{ getVeriffHitTypesString(item) }}</b></div>
                    <div style="margin-left: 10px;" *ngIf="item.dob">Dob: {{ item.dob | date: "dd.MM.yyyy" }} </div>
                    <div style="margin-left: 10px;" *ngIf="item.dod">Dod: {{ item.dod | date: "dd.MM.yyyy" }} </div>
                    <div style="margin-left: 10px;" *ngIf="item.matchTypes">Types: {{ item.matchTypes }} </div>
                    <div style="margin-left: 10px;" *ngIf="item.countries">Countries: {{ item.countries }} </div>
                    <div style="margin-left: 10px;" *ngIf="item.associates">Associates: {{ item.associates }} </div>
                    <br />
                    <div *ngFor="let item of item.sources" style="margin-left: 15px;">
                      <div> {{ getVerifHitTypeEmoji(item.hitType) }} {{ getVerifHitTypeString(item.hitType) }} </div>
                      <div style="margin-left: 10px;" *ngIf="item.date">Date: {{ item.date | date: "dd.MM.yyyy" }} </div>
                      <div style="margin-left: 10px;" *ngIf="item.name">Name: {{ item.name }} </div>
                      <div style="margin-left: 10px;" *ngIf="item.url">URL: <a href="{{item.url}}" target="_blank">{{ item.url }}</a></div>

                    </div>
                  </div>
                </div>


              </mat-expansion-panel>
            </div>




          </label>
        </div>
        <div class="list-item" fxLayout="row">
          <label fxFlex="15" class="secondary">Current Status</label>
          <label fxFlex="65" >
            <div *ngIf="row.pepStatus == pepStatus.falsePositive">
              <span style="color: green">False positive</span>
            </div>
            <div *ngIf="row.pepStatus == pepStatus.confirmedMatch">
              <span style="background-color: red; color: white; padding: 4px; border-radius: 4px;">PEP confirmed</span>
            </div>
            <div *ngIf="row.pepStatus == pepStatus.possibleMatch">
              <span style="background-color: orange; padding: 4px; border-radius: 4px;">Possible match</span>
            </div>
          </label>
        </div>



      </mat-card-content>
      <mat-card-actions align="start">

        <button mat-button *ngIf="row.pepStatus == pepStatus.possibleMatch" [disabled]="!currentUserIsAdminOrComplianceOrFinanceManagerOrManager()" (click)="ignorePepMatch(row)">
          <mat-icon style="color: green">delete</mat-icon> False positive
        </button>

        <button mat-button *ngIf="row.pepStatus == pepStatus.possibleMatch" [disabled]="!currentUserIsAdminOrComplianceOrFinanceManagerOrManager()" (click)="confirmPepMatch(row)">
          <mat-icon style="color: red;">beenhere</mat-icon> Confirm PEP match
        </button>

      </mat-card-actions>
    </mat-card>
  </ng-container>



  <app-mat-table-generator #table [hidden]="false" [showOnlyPaginator]="true" [pageSizeOptions]="[5, 10, 20, 50, 100, 500, 1000, 2500]"
                           tableName="pepTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [deleteEnabled]="false"
    [multiselectEnabled]="false"
    [saveFilters]=false
    [customActions]="customActions"
    >
  </app-mat-table-generator>
</mat-card>
